{
  "palette": {
    "50": "#f0fdf4",
    "100": "#dcfce7",
    "200": "#bbf7d0",
    "300": "#86efac",
    "400": "#4ade80",
    "500": "#22c55e",
    "600": "#16a34a",
    "700": "#15803d",
    "800": "#166534",
    "900": "#14532d",
    "950": "#052e16"
  },
  "light": {
    "primary": "#08783f",
    "hover": "#066633",
    "foreground": "#f3fff7"
  },
  "dark": {
    "primary": "#46c383",
    "hover": "#65d49b",
    "foreground": "#082315"
  }
}
